import Vue from 'vue';
import firebase from 'firebase';
import 'firebase/firestore';

const localState = {
  user: {},
  loaded: false,
  attemptedRoute: null,
};

export const getters = {
  isAdmin({ user }) {
    return user.role === 'admin';
  },

  isAuthenticated({ user }) {
    return Boolean(user.email);
  },
};

export const mutations = {
  SET_USER(state, user) {
    const {
      name,
      email,
      role,
      uid,
    } = user;

    Vue.set(state, 'user', {
      name,
      email,
      role,
      uid,
    });

    Vue.set(state, 'loaded', true);
  },

  LOGOUT(state) {
    Vue.set(state, 'user', {});
  },

  SET_ATTEMPTED_ROUTE(state, attemptedRoute) {
    state.attemptedRoute = attemptedRoute;
  },
};

export const actions = {
  LOGIN({ state, commit }, { uid }) {
    return new Promise((resolve) => {
      if (state.user.role) {
        resolve(state.user);
      } else {
        firebase.firestore().collection('users').doc(uid)
          .onSnapshot((doc) => {
            const currentUser = doc.data();
            currentUser.uid = uid;

            commit('SET_USER', currentUser);
            commit('draft/SET_DRAFTS', currentUser.drafts, { root: true });
            resolve(state.user);
          });
      }
    });
  },

  CREATE_USER(context, { user, name }) {
    return firebase.firestore().collection('users').doc(user.uid).set({
      name: name || '',
      email: user.email,
      role: 'user',
    });
  },
};

export const state = localState;

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
